// Footer commun avec mentions légales — Hsasoft / HInvoice
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-12 border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
        <p>
          © {year}{" "}
          <span className="font-medium text-slate-500">Hsasoft</span> — HInvoice.{" "}
          {t("footer.copyright")}
        </p>
        <nav className="flex items-center gap-4">
          <Link to="/legal" className="hover:text-brand-600 transition-colors">
            {t("footer.legalLink")}
          </Link>
          <span className="text-slate-200">|</span>
          <a
            href="mailto:contact@hsasoft.com"
            className="hover:text-brand-600 transition-colors"
          >
            {t("footer.contact")}
          </a>
        </nav>
      </div>
    </footer>
  );
}
